module.exports = __webpack_public_path__ + "img/bnr_submit.4d80c22f.png";